export const generateTestId = (text: string | number) => {
  return text.toString().toLowerCase().replaceAll(' ', '_');
};
